import BaseAccountController from '../../lib/controllers/BaseAccountController';

export default class EditEmailController extends BaseAccountController {
	public static $inject: string[] = ['$scope', 'UserEmailResource'];

	public currentEmail: string;
	public errorMessage: string;
	public newEmailErrorMessage: string;
	public confirmationErrorMessage: string;
	public updateSuccessful: boolean;

	private readonly UserEmail: MyAccountApi.IUserEmailResource;
	private userEmail: MyAccountApi.IUserEmail;

	constructor($scope: ng.IScope, UserEmail: MyAccountApi.IUserEmailResource) {
		super($scope);

		this.UserEmail = UserEmail;
		this.updateSuccessful = false;
		this.currentEmail = '';
	}

	public updateEmail(newEmail: string, newEmailConfirmation: string): void {
		this.updateSuccessful = false;

		this.validateNewEmail(newEmail);
		this.validateConfirmation(newEmail, newEmailConfirmation);

		if (!this.newEmailErrorMessage && !this.confirmationErrorMessage) {
			this.userEmail.emailAddress = newEmail;
			this.userEmail.$save(() => {
				this.updateSuccessful = true;
				this.currentEmail = newEmail;
			}, () => {
				this.newEmailErrorMessage = 'Sorry, that seems to be an invalid email format.';
			});
		}
	}

	public validateNewEmail(newEmail: string): void {
		this.newEmailErrorMessage = this.performValidation(newEmail);
	}

	public validateConfirmation(newEmail: string, newEmailConfirmation: string): void {
		if (newEmail !== newEmailConfirmation) {
			this.confirmationErrorMessage = 'Sorry, the email addresses entered don’t match.';
		} else {
			this.confirmationErrorMessage = '';
		}
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		// load My Account user details
		this.userEmail = this.UserEmail.get((userEmail: MyAccountApi.IUserEmail) => {
			// load club visits
			this.currentEmail = userEmail.emailAddress;
		});
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}

	private performValidation(emailAddress: string): string {
		const genericMessage = 'Sorry, that seems to be an invalid email format.';

		if (emailAddress == null) {
			return genericMessage;
		}

		const splitEmail = emailAddress.split('@');
		if (splitEmail.length !== 2) {
			return genericMessage;
		}

		const startWithError = /^(\.|www\.|https?)/.test(emailAddress);
		if (startWithError) {
			return genericMessage;
		}

		const localPart = splitEmail[0];
		const domainPart = splitEmail[1];
		const domainSplit = domainPart.split('.');

		if (localPart.length >= 65) {
			return 'Your new email address must be 140 characters or less.';
		}
		const tld = domainSplit[domainSplit.length - 1];

		if (domainSplit.length < 2) {
			return genericMessage;
		} else if (domainSplit.length === 2 && !domainSplit[0]) {
			return genericMessage;
		} else if (domainSplit.length >= 2) {
			let isError = false;
			domainSplit.forEach((dom: string) => {
				if (/^\-/.test(dom) || /\-$/.test(dom)) {
					isError = true;
				}
			});

			if (isError) {
				return genericMessage;
			}
		}

		if (tld.length < 2 || tld.length > 7) {
			return genericMessage;
		}

		if (emailAddress.length > 140) {
			return 'Your new email address must be 140 characters or less.';
		}

		if (/[^0-9a-zA-Z-.]/.test(splitEmail[1])) {
			return genericMessage;
		}

		if (/[^!#$%&'*/=-?^_{|}~.0-9a-zA-Z-\\+]/.test(localPart)) {
			return genericMessage;
		}

		return '';
	}
}
